import {
  signInWithEmailAndPassword,
  updatePassword as firebaseUpdatePassword,
} from 'firebase/auth';

export const updatePassword = async (auth, oldPassword, newPassword) => {
  await signInWithEmailAndPassword(auth, auth.currentUser.email, oldPassword);
  await firebaseUpdatePassword(auth.currentUser, newPassword);
};
